import * as React from "react";
import { useContext, useRef, useState } from "react";
import styles from '../../styles/pokemon.module.scss';
import { Image, Popup, mergeStyleSets } from "@fluentui/react";
import ImageViewerSplashContext from "../../_contexts/ImageViewerContext";
import GlobalContext from "../../_contexts/GlobalContext";

export interface IImageViewerSplashProps {
    // eslint-disable-next-line
}

export const popupStyles = mergeStyleSets({
  root: {
    background: 'rgba(0, 0, 0, 0.5)',
    bottom: '0',
    left: '0',
    position: 'fixed',
    right: '0',
    top: '0',
    zIndex:999
  },
  content: {
    backgroundColor: "transparent",
    left: '50%',
    padding: '0 2em 2em',
    position: 'absolute',
    maxWidth: "90%!important",
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

const ImageViewerSplash : React.FunctionComponent<IImageViewerSplashProps> = (props : IImageViewerSplashProps) => {   
    const { imgUrl,setImgUrl } = useContext(ImageViewerSplashContext);
    const [ mousePositionX, setMousePositionX] = useState<number>();
    const [ mousePositionY, setMousePositionY] = useState<number>();
    const [ magBGPosX, setmagBGPosX] = useState<number>();
    const [ magBGPosY, setmagBGPosY] = useState<number>();

    const { windowSize } = useContext(GlobalContext);

    const ImgRef = useRef<HTMLImageElement>(null);
    const zoom = 2;
    const magnifierSizeX = 150;
    const magnifierSizeY = 150;

    function moveMagnifier(e) {
        const x = e.nativeEvent.offsetX-(magnifierSizeX / 2);
        const y = e.nativeEvent.offsetY-(magnifierSizeY / 2);
        setMousePositionX(x);
        setMousePositionY(y);        
        setmagBGPosX(-(x*zoom)-magnifierSizeX/2);
        setmagBGPosY(-(y*zoom)-magnifierSizeY/2); 
    }

    return (
        <Popup
            hidden={!imgUrl}
            role="dialog"
            aria-modal="true"
            className={popupStyles.root}
        >
            <div role="document" className={`${popupStyles.content} ${styles.imgmagnifiercontainer}`}>
                <div className={styles.imgmagnifierglass} 
                     style={{top:mousePositionY,
                             left:mousePositionX, 
                             width: magnifierSizeX,
                             height: magnifierSizeY,
                             backgroundSize: `${ImgRef.current?.width * zoom}px ${ImgRef.current?.height * zoom}px`,
                             backgroundPositionX:magBGPosX, 
                             backgroundPositionY:magBGPosY, 
                             backgroundRepeat:"no-repeat", 
                             backgroundImage:`url('${imgUrl}')` }} />
                <Image  className={`${styles.popupImage}`}
                        ref={ImgRef}
                        style={{cursor: "none", maxHeight: windowSize.y - ((windowSize.y/100) * 25), height: windowSize.y - ((windowSize.y/100) * 25)}}
                        onError={(e) => { e.currentTarget.onerror = null;
                                          e.currentTarget.src=`${imgUrl}`}}
                        onClick={() => {setImgUrl(undefined)}}
                        onTouchMove={moveMagnifier}
                        onMouseMove={moveMagnifier}
                        src={imgUrl}
                        alt="" />
            </div>
        </Popup>
    );
}

export default ImageViewerSplash;